<template>
    <article-create-edit-form isEdit/>
</template>

<script>
import ArticleCreateEditForm from './components/ArticleCreateEditForm.vue';

export default {
    components:{
        ArticleCreateEditForm
    }
}
</script>
